import styled from '@emotion/styled';
import { Layout } from 'antd';
import { LayoutProps } from 'antd/lib/layout';
import React from 'react';
import { theme } from '../../configs/styled';

const ContentBase = Layout.Content;

export interface ILayoutProps extends LayoutProps {}

const Content: React.FC<ILayoutProps> = ({ children, ...props }) => {
  return <ContentBase {...props}>{children}</ContentBase>;
};

export default styled(Content)`
  background-color: ${theme.palettes.primaryBackground};
  padding: ${theme.spacing.xl};
  margin: 0;
  height: 100vh;
`;
